export default {
  SET_LIST_USERS (state, list) {
    state.list = list;
  },
  SET_LIST_USERS_PRINT (state, list) {
    state.listPrint = list;
  },
  SET_LIST_USERS_FOR_SELECT (state, list) {
    state.listSelect = list;
  },
  SET_USER_LIST_PAGE (state, currentPage) {
    state.listPaginate.currentPage = currentPage;
  },
  SET_USER_LIST_TOTAL_PAGES (state, totalPages) {
    state.listPaginate.totalPages = totalPages;
  },
  SET_LIST_USERS_STATISTICS (state, list) {
    state.listUsersStatistics = list.status;
  },
  ADD_USER_LIST_FILTER (state, filters) {
    if (state.listFilters.indexOf(filters) === -1) {
      state.listFilters.push(filters);
    }
  },
  REMOVE_USER_LIST_FILTER (state, filters) {
    if (state.listFilters.indexOf(filters) !== -1) {
      state.listFilters.splice(state.listFilters.indexOf(filters), 1);
    }
  },
  SET_USER_LIST_SEARCH (state, search) {
    state.listSearch = search;
  },
  SET_USER_LIST_SORT (state, header) {
    const newSort = {};

    if (state.listSort.constructor === Object && header && header.name) {
      if (!(header.name in state.listSort)) {
        newSort[header.name] = 'asc';
      } else {
        if (state.listSort[header.name] === 'asc') {
          newSort[header.name] = 'desc';
        }
        if (state.listSort[header.name] === 'desc') {
          newSort[header.name] = 'asc';
        }
      }
      state.listSort = newSort;
    }
  },
  SET_LIST_PLAYERS_FOR_SELECT (state, list) {
    state.listPlayerSelect = list;
  },
};
